import React, { useState } from "react";

import "./styles.css";

/**
 * @param {String} label: input label
 * @param {String} placeholder: input placeholder
 * @param {String} name: input name
 * @param {String} type: input type
 * @param {Function} getInputValue: collect the value of the input as its being typed
 * @param {String} max: the maximum length of characters required
 * @param {Boolean} withError: a boolean value to show an error state for the input
 */
const TextInput = ({
  type,
  label,
  placeholder,
  name,
  style,
  inputStyles,
  onChange,
  showPassword,
  isPasswordVisible,
  setIsFocused,
  value,
  disabled,
  isRequired,
  max,
  withError,
  errorMessage,
  autocomplete,
  showInputIcon,
  showLeftIcon,
  icon,
  onBlur,
}) => {
  const [visible, setVisible] = useState(false);

  const togglePassword = () => {
    setVisible(!visible);
  };

  const classnames = withError ? `${name} hasError` : name;
  return (
    <div
      className={`textinput__container ${
        showLeftIcon && `override--inputPadding`
      } ${disabled && `input--disabled`}`}
      style={style}
    >
      <label>{label}</label>
      {type === "password" ? (
        <input
          className={classnames}
          type={visible ? "text" : type}
          name={name}
          placeholder={placeholder}
          style={inputStyles}
          onFocus={setIsFocused}
          onChange={onChange}
          required={isRequired}
          disabled={disabled}
          value={value}
          onBlur={onBlur}
        />
      ) : (
        <>
          <input
            className={classnames}
            autoFocus
            type={type}
            name={name}
            placeholder={placeholder}
            style={inputStyles}
            onChange={onChange}
            required={isRequired}
            maxLength={max}
            autoComplete={autocomplete}
            disabled={disabled}
            value={value}
            onBlur={onBlur}
          />
        </>
      )}

      {name === "password" ? (
        <div onClick={togglePassword}>
          {visible ? (
            <svg
              width="17"
              height="11"
              viewBox="0 0 17 11"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.5 1.46667C11.4286 1.46667 14.0405 3.02867 15.3155 5.5C14.0405 7.97133 11.4286 9.53333 8.5 9.53333C5.57136 9.53333 2.95955 7.97133 1.68455 5.5C2.95955 3.02867 5.57136 1.46667 8.5 1.46667ZM8.5 0C4.63636 0 1.33682 2.28067 0 5.5C1.33682 8.71933 4.63636 11 8.5 11C12.3636 11 15.6632 8.71933 17 5.5C15.6632 2.28067 12.3636 0 8.5 0ZM8.5 3.66667C9.56636 3.66667 10.4318 4.488 10.4318 5.5C10.4318 6.512 9.56636 7.33333 8.5 7.33333C7.43364 7.33333 6.56818 6.512 6.56818 5.5C6.56818 4.488 7.43364 3.66667 8.5 3.66667ZM8.5 2.2C6.58364 2.2 5.02273 3.68133 5.02273 5.5C5.02273 7.31867 6.58364 8.8 8.5 8.8C10.4164 8.8 11.9773 7.31867 11.9773 5.5C11.9773 3.68133 10.4164 2.2 8.5 2.2Z"
                fill="black"
              />
            </svg>
          ) : (
            <svg
              width="17"
              height="13"
              viewBox="0 0 17 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.5 2.46667C11.4286 2.46667 14.0405 4.02867 15.3155 6.5C14.0405 8.97133 11.4286 10.5333 8.5 10.5333C5.57136 10.5333 2.95955 8.97133 1.68455 6.5C2.95955 4.02867 5.57136 2.46667 8.5 2.46667ZM8.5 1C4.63636 1 1.33682 3.28067 0 6.5C1.33682 9.71933 4.63636 12 8.5 12C12.3636 12 15.6632 9.71933 17 6.5C15.6632 3.28067 12.3636 1 8.5 1ZM8.5 4.66667C9.56636 4.66667 10.4318 5.488 10.4318 6.5C10.4318 7.512 9.56636 8.33333 8.5 8.33333C7.43364 8.33333 6.56818 7.512 6.56818 6.5C6.56818 5.488 7.43364 4.66667 8.5 4.66667ZM8.5 3.2C6.58364 3.2 5.02273 4.68133 5.02273 6.5C5.02273 8.31867 6.58364 9.8 8.5 9.8C10.4164 9.8 11.9773 8.31867 11.9773 6.5C11.9773 4.68133 10.4164 3.2 8.5 3.2Z"
                fill="black"
              />
              <path d="M14 1L3 12" stroke="black" strokeLinecap="round" />
            </svg>
          )}
        </div>
      ) : null}
      {showLeftIcon && (
        <span className="input--icon">
          <img src={icon} alt="icon" />
        </span>
      )}

      {withError && <p>{errorMessage}</p>}
    </div>
  );
};

export default TextInput;
